import PageTabTitle from "../../../global/components/PageTabTitle/PageTabTitle.vue";
import PuxPageDetails from "../../../global/components/PuxPageDetails/PuxPageDetails.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";
import SachberichtModalCreate from "../SachberichtModalCreate/SachberichtModalCreate.vue";
import SmartTable from "../../../global/components/table/table.vue";

import getTableApi from "../../../const/TableApis";

const TABLE_ID = "sachbericht";

// @vue/component
export default {
  name: "SachberichtList",
  components: {
    PageTabTitle,
    PuxPageDetails,
    PuxTranslate,
    SachberichtModalCreate,
    SmartTable,
  },
  data() {
    return {
      tableId: TABLE_ID,
      options: {
        id: TABLE_ID,
        url: getTableApi({ id: TABLE_ID }),
        rowActions: [
          {
            label: "_LBL_SACHBERICHT_LIST_ROW_ACTION_DETAILS_",
            route: "root.sachberichtvorlagen.detail",
            routeParameters: [{ routeId: "id", rowPath: "pk" }],
          },
        ],
        actions: [
          {
            permission: "sachberichtvorlage.create",
            label: "_TXT_LIST_SACHBERICHTVORLAGE_NEUE_",
            callback: () => this.modal.create = true,
            type: "button",
            className: "btn btn-primary",
            icon: "glyphicon-plus",
            htmlId: "sachberichtvorlage_create",
          },
        ],
        label: "_TXT_LIST_SACHBERICHTVORLAGE_",
        sortable: true,
        pagination: true,
        details: false,
        view: {
          filter: "top",
        },
      },
      modal: {
        create: undefined,
      },
    };
  },
  methods: {
    closeModalCreate() {
      this.modal.create = false;
    },
  },
};
